import React from "react";
import {
  qhseBg,
  supplyResato10,
  supplyResato11,
  supplyResato9,
  supplyResatoPrez7,
  supplyResatoPrez8,
} from "../../../../assets/images";
import { useTranslation } from "react-i18next";
import SubOtherHero from "../../../../Components/Breadcrumb/SubOtherHero/SubOtherHero";

const Pressure = () => {
  const { t } = useTranslation();

  return (
    <>
      <div
        className="bg-black/60"
        style={{
          position: "relative",
          overflow: "hidden",
          backgroundImage: `url(${qhseBg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          width: "100%",
          height: window.innerWidth < 640 ? "200px" : "300px",
        }}
      >
        <SubOtherHero title="Pressure testing: Pressure test bays" />
      </div>

      <div className="bg-[#EDEDED] py-10 md:py-20">
        <div className="max-w-containerSm md:max-w-container mx-auto ">
          {/* Main Text */}
          <p className="text-[22px] md:text-[44px] font-bold text-[#141615] font-firstFont">
            {t("Pressure testing: Pressure test bays")}
          </p>
          {/* LTB */}
          <div className="md:flex md:items-start md:justify-between gap-10 flex-col md:flex-row mt-10">
            <div className="md:w-1/2">
              <p className="mt-6 text-[20px] font-semibold text-[#141615]">
                {t("Pressure testing: Pressure test bays")}
              </p>
              <p className="mt-6 text-[20px] font-semibold text-[#141615]">
                {t("LTB: Long test box")}
              </p>

              <p className="mt-5 text-[14px] md:text-[20px] text-[#41444B]">
                {t("Outlet pressure range: Various pressure ranges")}
              </p>
              <p className="mt-5 text-[14px] md:text-[20px] text-[#41444B]">
                {t("Materials: Double plated side walls and 20 mm lid")}
              </p>
              <p className="mt-5 text-[14px] md:text-[20px] text-[#41444B]">
                {t("Mediums: Fluids only")}
              </p>
              <p className="mt-5 text-[14px] md:text-[20px] text-[#41444B]">
                {t(
                  "With the modular designed test box, a variety of objects can be safely pressurized, tested and monitored with minimal loss of valuable workshop space. The simplicity of the hydraulically opened lid and integrated thick walled plated steel, ensures a safe test environment for the operator in the workshop. The lid has a door lock and a door switch safety system. By use of a dual pump setup and multiple pressure transmitters the test box can generate test certificates for a wide range of test pressures."
                )}
              </p>
              <p className="mt-6 text-[20px] font-semibold text-[#141615]">
                {t("Benefits & Features")}
              </p>
              <ul className="mt-4 text-[14px] md:text-[20px] text-[#41444B] list-disc list-inside space-y-3">
                <li>
                  {t(
                    "Reduce testing time of objects via pre-filling pump and multiple pump setup"
                  )}
                </li>
                <li>
                  {t(
                    "To ensure safe operating, a locking mechanism is integreated into te text box and the text box can only be pressurize when the lid is closed"
                  )}
                </li>
                <li>{t("Camera system integrated in testbox")}</li>
                <li>
                  {t("Forklift pockets, to move the testbox around easily")}
                </li>
                <li>
                  {t(
                    "Sump pit on testbox floor to pump fluids back to reservoir, enabling re-use of test fluid"
                  )}
                </li>
                <li>
                  {t("Hydraulic cylinders to open and close the lid easily")}
                </li>
                <li>
                  {t(
                    "Can be designed according to your general safety design criteria"
                  )}
                </li>
              </ul>
              <p className="mt-6 text-[20px] font-semibold text-[#141615]">
                {t("Application Areas")}
              </p>
              <ul className="mt-4 text-[14px] md:text-[20px] text-[#41444B] list-disc list-inside space-y-3">
                <li>{t("Hydrostatic pressure testing")}</li>
                <li>{t("Cycle testing")}</li>
                <li>{t("Leak testing")}</li>
              </ul>
              <p className="mt-6 text-[20px] font-semibold text-[#141615]">
                {t("Options")}
              </p>
              <ul className="mt-4 text-[14px] md:text-[20px] text-[#41444B] list-disc list-inside space-y-3">
                <li>{t("Additional control lines")}</li>
                <li>{t("Additional length in 5-meter sections")}</li>
              </ul>

              <a
                href={`${supplyResatoPrez7}`}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block bg-[#B31F11] text-white py-2 px-4 rounded-md transition-colors mt-5"
              >
                {t("To learn more information please download datasheet")}
              </a>
              <a
                href="https://www.youtube.com/watch?v=4RKVTjwfsRE"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block bg-[#B31F11] text-white py-2 px-4 rounded-md transition-colors mt-5"
              >
                {t("To learn please watch video")}
              </a>
            </div>

            {/* Right Image */}
            <div className="md:w-1/2 gap-4 mt-8 md:mt-0">
              <img
                src={supplyResato9}
                alt="Drill Bit 1"
                className="w-full rounded-lg shadow-md"
              />
            </div>
          </div>
          {/* PPU */}
          <div className="md:flex md:items-start md:justify-between gap-10 flex-col md:flex-row mt-10">
            <div className="md:w-1/2">
              <p className="mt-6 text-[20px] font-semibold text-[#141615]">
                {t("PPU: Containerized pressure test bay")}
              </p>

              <p className="mt-5 text-[14px] md:text-[20px] text-[#41444B]">
                {t("Outlet pressure range: Various pressure ranges")}
              </p>
              <p className="mt-5 text-[14px] md:text-[20px] text-[#41444B]">
                {t("Materials: Double plated side walls and 20 mm lid")}
              </p>
              <p className="mt-5 text-[14px] md:text-[20px] text-[#41444B]">
                {t("Mediums: Fluids only")}
              </p>
              <p className="mt-5 text-[14px] md:text-[20px] text-[#41444B]">
                {t(
                  "With the modular designed test box, a variety of objects can be safely pressurized, tested and monitored with minimal loss of valuable workshop space. The simplicity of the hydraulically opened lid and integrated thick walled plated steel, ensures a safe test environment for the operator in the workshop. The lid has a door lock and a door switch safety system. By use of a dual pump setup and multiple pressure transmitters the test box can generate test certificates for a wide range of test pressures."
                )}
              </p>
              <p className="mt-6 text-[20px] font-semibold text-[#141615]">
                {t("Benefits & Features")}
              </p>
              <ul className="mt-4 text-[14px] md:text-[20px] text-[#41444B] list-disc list-inside space-y-3">
                <li>
                  {t(
                    "Reduce testing time of objects via pre-filling pump and multiple pump setup"
                  )}
                </li>
                <li>
                  {t(
                    "To ensure safe operating, a locking mechanism is integreated into te text box and the text box can only be pressurize when the lid is closed"
                  )}
                </li>
                <li>{t("Camera system integrated in testbox")}</li>
                <li>
                  {t("Forklift pockets, to move the testbox around easily")}
                </li>
                <li>
                  {t(
                    "Sump pit on testbox floor to pump fluids back to reservoir, enabling re-use of test fluid"
                  )}
                </li>
                <li>
                  {t("Hydraulic cylinders to open and close the lid easily")}
                </li>
                <li>
                  {t(
                    "Can be designed according to your general safety design criteria"
                  )}
                </li>
              </ul>
              <p className="mt-6 text-[20px] font-semibold text-[#141615]">
                {t("Application Areas")}
              </p>
              <ul className="mt-4 text-[14px] md:text-[20px] text-[#41444B] list-disc list-inside space-y-3">
                <li>{t("Hydrostatic pressure testing")}</li>
                <li>{t("Cycle testing")}</li>
                <li>{t("Leak testing")}</li>
              </ul>
              <p className="mt-6 text-[20px] font-semibold text-[#141615]">
                {t("Options")}
              </p>
              <ul className="mt-4 text-[14px] md:text-[20px] text-[#41444B] list-disc list-inside space-y-3">
                <li>{t("Additional control lines")}</li>
                <li>{t("Additional length in 5-meter sections")}</li>
              </ul>

              <a
                href={`${supplyResatoPrez8}`}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block bg-[#B31F11] text-white py-2 px-4 rounded-md transition-colors mt-5"
              >
                {t("To learn more information please download datasheet")}
              </a>
              <a
                href="https://www.youtube.com/watch?v=OlJHu9yuE5A"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block bg-[#B31F11] text-white py-2 px-4 rounded-md transition-colors mt-5"
              >
                {t("To learn please watch video")}
              </a>
            </div>

            {/* Right Image */}
            <div className="md:w-1/2 gap-4 mt-8 md:mt-0">
              <img
                src={supplyResato10}
                alt="Drill Bit 1"
                className="w-full rounded-lg shadow-md"
              />
            </div>
          </div>
          {/* Customers */}
          <div className="md:flex md:items-start md:justify-between gap-10 flex-col md:flex-row mt-10">
            <div>
              <p className="mt-6 text-[20px] font-semibold text-[#141615]">
                {t(
                  "All our customers trust our products & services for Pressure testing:"
                )}
              </p>
              <img
                src={supplyResato11}
                alt="Drill Bit 1"
                className="w-full rounded-lg shadow-md mt-10"
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Pressure;
